export const TYPES = {
  GENERIC_REQUEST: 'GENERIC_REQUEST',
  GENERIC_ERROR: 'GENERIC_ERROR',
  FETCH_IP_STATUS_SUCCESS: 'FETCH_IP_STATUS_SUCCESS',
};

export default {
  [TYPES.GENERIC_REQUEST](state, type) {
    const currentState = state;
    currentState[type].loading = true;
    currentState[type].successMessage = '';
    currentState[type].errorMessage = '';
  },
  [TYPES.GENERIC_ERROR](state, errorInfo) {
    const currentState = state;
    currentState[errorInfo.type].errorMessage = errorInfo.message;
    currentState[errorInfo.type].successMessage = '';
    currentState[errorInfo.type].loading = false;
  },
  [TYPES.FETCH_IP_STATUS_SUCCESS](state, ipStatus) {
    const currentState = state;
    let mockState = {};

    // mock response for E2E tests in CI env
    if (process.env.VUE_APP_MOCK) {
      mockState = {
        country_code: 'US',
        country_name: 'United States of America',
        ip: '148.167.115.188',
        region: 'Arizona',
        region_code: 'AZ',
      };
    }

    currentState.ipStatus = {
      ...currentState.ipStatus,
      loading: false,
      ...ipStatus,
      ...mockState,
    };
  },
};
